const ApiAttributesKeys = {
  readingNameKey: 'readingName',
  freeQuestionCountKey: 'totalFreeQuestion',
  TotalNotesCountKey: 'totalNotes',
  chapterIdKey: 'chapterId',
  chapterNameKey: 'chapter_name',
  chapterOrderKey: 'chapter_order',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Notes/ReadingList/ApiAttributesKeys.js